import React from "react";
import "./inputRadio.css";

/**
 * type is for the input type itself
 * inputType is to choose between "textarea" or 'input'
 * error is the error state of the textField
 * icon should take icons in a html elements
 * errorText holds the error message if you want to show one
 *
 */
const InputRadio = ({
  onClick,
  type,
  placeholder,
  value,
  className,
  onChange,
  disabled,
  name,
  required,
  error,
  htmlFor,
  radioText,
  checked,
  checkboxLabel,
  radioLabel,
  ...restProps
}) => {
  return (
    <label className="container">
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onClick={onClick}
        disabled={disabled}
        onChange={onChange}
        name={name}
        required={required}
        checked={checked}
        {...restProps}
      />
      <span className="checkmark"></span>
      {radioText}
    </label>
  );
};

export { InputRadio };
